import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { ButtonComponent } from '../components/common/components/button/button.component';
import {MatCheckboxModule} from '@angular/material/checkbox';

@Component({
  selector: 'app-chat-history-selection',
  standalone: true,
  imports: [MatDialogModule,CommonModule,MatIconModule,MatSelectModule,ButtonComponent,MatCheckboxModule],
  templateUrl: './chat-history-selection.component.html',
  styleUrl: './chat-history-selection.component.scss'
})
export class ChatHistorySelectionComponent implements OnDestroy {
  selectedQuestion: string = "";
  // chatData: {question: string,answer: string, message_id: string}[] = [];
  // selectedChatData: {question: string,answer: string, message_id: string}[] = [];
  chatData: {message_text: string, message_id: string, type: string}[] = [];
  selectedChatData: {message_text: string, message_id: string, type: string}[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<ChatHistorySelectionComponent>,private dialog: MatDialog ) {
      if (data) {
      
        // console.log("item ",item);
        //           let message_text;
        //           if(this.template_converted){
        //             message_text = marked(item.message_text)
        //             console.log("if item" ,message_text);
        //            }else{
        //             message_text = marked(this.escapeNonHtmlTags(item.message_text))
        //             console.log(" item" ,message_text);
        //             } 
        this.selectedQuestion = data.selectedQuestion
        //let temp=data.chatData;
        // temp.forEach((data:any)=>{
        //    data.message_text=this.escapeNonHtmlTags(data.message_text)
        // })
        this.chatData = data.chatData.map((data:any)=>{
        
          return{
            ...data,
            message_text:this.escapeNonHtmlTags(data.message_text)
          }
          //  data.message_text=this.escapeNonHtmlTags(data.message_text)
          });
      
      }
      this.dialogRef.updateSize('300vw','300vw')
    }

    escapeNonHtmlTags(text: string): string {
      // Define a whitelist of valid HTML tags
      const validTags = ['b', 'i', 'u', 'strong', 'em', 'p', 'br', 'span', 'div', 'ul', 'li', 'ol', 'a', 'img', 'table', 'tr', 'td', 'th', 'thead', 'tbody', 'tfoot'];
    
      return text.replace(/<\/?([a-zA-Z0-9-]+)[^>]*>/g, (match, tag) => {
        // If the tag is in the valid list, return it unchanged
        if (validTags.includes(tag.toLowerCase())) {
          return match;
        }
        // Otherwise, escape it
        return match.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      });
    }

    selectChat(event: any, chat: any) {
     
      if(event.checked) {
        this.selectedChatData.push(chat)
      } else {
        this.selectedChatData = this.selectedChatData.filter((item:any) => item.message_text != chat.message_text)
      }
     
    }

    onClose(){
      this.dialogRef.close({type: 'cancled'});
    }

    onSubmit(event : any){
      this.dialogRef.close({type: 'submitted', selectedChatData: this.selectedChatData});
    }

    ngOnDestroy() {
      // this.dialogRef.close({type: 'cancled'});
    }
  
}
